// @flow

import { STATUS_LOADING, STATUS_FAILURE, STATUS_SUCCESS } from 'constants/statusConstants';
import { FETCH_YOUTUBE_START, FETCH_YOUTUBE_SUCCESS, FETCH_YOUTUBE_FAILURE } from 'actions/youtubeActions';

import type { YoutubeContent } from 'types/YoutubeContent';
import type { Status } from 'types/Status';
import type { ActionType } from 'types/Actions';

export type State = {
  posts: Array<YoutubeContent>,
  status: Status
};

const initialState: State = {
  posts: [],
  status: STATUS_LOADING
};

export default function(state: State = initialState, action: ActionType): State {
  switch (action.type) {
    case FETCH_YOUTUBE_START:
      return {
        ...state,
        status: STATUS_LOADING
      };
    case FETCH_YOUTUBE_SUCCESS:
      return {
        ...state,
        posts: action.payload.posts,
        status: STATUS_SUCCESS
      };
    case FETCH_YOUTUBE_FAILURE:
      return {
        ...state,
        status: STATUS_FAILURE
      };
    default:
      return state;
  }
}
